import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Translation } from '../Translation';
import { usePlatformConfig } from '../../hooks/usePlatformConfig';
import { WidgetTypes } from '../../enums/WidgetTypes';
const IvaLabel = ({ group, className, dataTest, widget, ...rest }) => {
    const { platformConfig: { platformFeatures: { carTypeWithIva } = {} }, } = usePlatformConfig();
    const isNotMatchingGroup = !carTypeWithIva || !group?.includes(carTypeWithIva);
    const label = useMemo(() => {
        switch (widget) {
            case WidgetTypes.CONFIGURATOR:
                return 'trans__configurator__price_display__additional_label';
            case WidgetTypes.CHECKOUT:
                return 'trans__checkout__vat_labels__vehicle_price';
            case WidgetTypes.MYACCOUNT:
                return 'trans__myaccount__price_display__additional_label';
            case WidgetTypes.FINANCE_CALCULATOR:
                return 'trans__fincalc__finance_breakdown__iva_included';
            default:
                return 'trans__configurator__price_display__additional_label1';
        }
    }, [widget]);
    if (isNotMatchingGroup) {
        return null;
    }
    return (_jsx(Translation, { id: label, "data-test": `${dataTest}:ivaLabel`, component: "Typography", componentProps: { ...rest }, className: className }, void 0));
};
export default IvaLabel;
//# sourceMappingURL=IvaLabel.js.map